import { Page, Card, BlockStack, InlineStack, Text, Divider, Box, AppProvider, Icon } from "@shopify/polaris";
import { CheckIcon } from "@shopify/polaris-icons";
import polarisStyles from "@shopify/polaris/build/esm/styles.css?url";

export const links = () => [{ rel: "stylesheet", href: polarisStyles }];

export function PrivacyContent() {
  return (
    <BlockStack gap="300">
      <Text as="p" fontWeight="bold">Overview</Text>
      <Text as="p">
        Revivify AI ("we," "us," or "the App") is committed to protecting the privacy of your customers. 
        This policy explains how we collect, use, and share personal information when you install the App 
        on your Shopify store.
      </Text>

      <Text as="h3" variant="headingSm">Data We Collect</Text>
      <BlockStack gap="200">
        <Text as="p">
          • <strong>Customer Personal Information:</strong> Name, email address, and order history provided via Shopify and Recharge APIs.
        </Text>
        <Text as="p">
          • <strong>Subscription Data:</strong> Subscription ID, product details, and charge dates.
        </Text>
        <Text as="p">
          • <strong>Interaction Data:</strong> Return request notes and customer feedback (processed by AI for intent analysis).
        </Text>
      </BlockStack>

      <Text as="h3" variant="headingSm">How We Use Your Data</Text>
      <BlockStack gap="200">
        <Text as="p">
          • <strong>Intent Analysis:</strong> We use the Google Gemini API to analyze customer notes to determine retention opportunities (e.g., "Overstock").
        </Text>
        <Text as="p">
          • <strong>Automation:</strong> To trigger "Skips" or "Delays" in the Recharge API based on your configured confidence thresholds.
        </Text>
        <Text as="p">
          • <strong>Reporting:</strong> To calculate and display your LTV Protected and ROI metrics.
        </Text>
      </BlockStack>

      <Text as="h3" variant="headingSm">Data Sharing & Third Parties</Text>
      <BlockStack gap="200">
        <Text as="p">
          • <strong>Google Gemini AI:</strong> Customer notes are sent to Google for processing. We ensure that data is not used to train global AI models under our enterprise agreement.
        </Text>
        <Text as="p">
          • <strong>Service Providers:</strong> We do not sell your data to third parties. Data is only shared with Shopify and Recharge to perform the core functions of the app.
        </Text>
      </BlockStack>
    </BlockStack>
  );
}

export default function PublicPrivacyPage() {
  return (
    <AppProvider i18n={{}}>
      <div style={{ backgroundColor: "#f4f6f8", minHeight: "100vh", paddingBottom: "100px" }}>
        <div style={{ 
          padding: '1.25rem 2.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'white',
          borderBottom: '1px solid #dfe3e8',
          position: 'sticky',
          top: 0,
          zIndex: 10
        }}>
          <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{ 
              width: '44px', 
              height: '44px', 
              backgroundColor: '#008060',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
            }}>
              <div style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', transform: 'scale(1.8)' }}>
                <Icon source={CheckIcon} tone="inherit" />
              </div>
            </div>
            <BlockStack gap="0">
              <Text variant="headingMd" as="h1" fontWeight="bold">Revivify AI</Text>
              <Text variant="bodyXs" as="p" tone="subdued">Legal Hub</Text>
            </BlockStack>
          </a>
          <a href="/" style={{ textDecoration: 'none' }}>
            <Text variant="bodyMd" tone="subdued" as="span">Back to Home</Text>
          </a>
        </div>

        <Page narrowWidth>
          <Box paddingBlockStart="800" paddingBlockEnd="800">
            <BlockStack gap="500">
              <Text variant="headingLg" as="h1">Privacy Policy</Text>
              <Card>
                <BlockStack gap="400">
                  <InlineStack align="space-between" blockAlign="center">
                    <Text as="h2" variant="headingMd">Revivify AI Privacy Policy</Text>
                    <Text tone="subdued" as="p">Last Updated: March 21, 2026</Text>
                  </InlineStack>
                  <Divider />
                  
                  <PrivacyContent />
                </BlockStack>
              </Card>
            </BlockStack>
          </Box>
        </Page>
      </div>
    </AppProvider>
  );
}
